import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
    return restApiRP.post("/api/shipping-alert", params);
}

const getChart = params => {
    return restApiRP.post("/api/shipping-alert/chart", params);
}

const getAllForCSV = params => {
    return restApiRP.post("/api/shipping-alert/csv", params);
}

const shippingAlertService = {
    getAll,
    getChart,
    getAllForCSV
}

export default shippingAlertService;